import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class AITableApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async reformatAITable(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.reformat_ai_table, formData);
  }
  public async saveRules(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.save_rules, formData);
  }

  public async deleteRules(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.delete_table_rules, formData);
  }
}
